/**
 * @param {String} s
 * @return {String}
 */
export const escapeUIPathElement = (s) => {
  return s.replace(/\//g, '%2F')
}

/**
 * @param {String} s
 * @return {String}
 */
export const unescapeUIPathElement = (s) => {
  return s.replace(/%2F/g, '/')
}
